import css from './index.module.scss';
import EfEmarsysEmail from '@elem/ui/ef-emarsys-email';
import moment from 'moment';
import { useGlobal } from '@/utils/useGlobal';
import EfSpec from '@elem/ui/ef-spec';
import { Swiper, SwiperSlide } from 'swiper/react';
import EfImg from '@elem/ui/ef-img';
import EfLink from '@elem/ui/ef-link';
import OFF from './OFF';
import OFF_M from './OFF_M';
import { useProductStore } from '@elem/compPage/Rapid/ProductProvider';
import NotifyModal from './NotifyModal';
import { createPortal } from 'react-dom';

export default function TheComp() {
    const { useRouter, useEffect, useState, useLang, getSystemTime } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('rapid.OtherA');
    const IS_NA = ['us', 'ca', 'mx'].includes(locale);
    const IS_EU = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'nl', 'kr'].includes(locale);
    const [showNotify, setShowNotify] = useState(false);
    const [isClient, setIsClient] = useState(false);
    const { pageStatus } = useProductStore();
    const systemTime = getSystemTime();
    const date = moment(systemTime).format('YYYY-MM-DD');
    const emailConfigMap: any = {
        us: {
            contactListId: ['744576608', '1157235157'],
            isMulti: true,
            fields: [
                {
                    id: '11149',
                    type: 'text',
                    value: date,
                    overwrite: true,
                },
                {
                    id: '11150',
                    type: 'multiple',
                    value: [3],
                    overwrite: false,
                },
                {
                    id: '31',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '4423',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '9435',
                    type: 'multiple',
                    value: [15],
                    overwrite: false,
                },
            ],
        },
        ca: {
            contactListId: ['744576608', '1157235157'],
            isMulti: true,
            fields: [
                {
                    id: '11149',
                    type: 'text',
                    value: date,
                    overwrite: true,
                },
                {
                    id: '11150',
                    type: 'multiple',
                    value: [3],
                    overwrite: false,
                },
                {
                    id: '31',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '4424',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '9435',
                    type: 'multiple',
                    value: [15],
                    overwrite: false,
                },
            ],
        },
        eu: {
            contactListId: ['324184408'],
            fields: [
                {
                    id: '9690',
                    type: 'multiple',
                    value: [12],
                    overwrite: false,
                },
                {
                    id: '7596',
                    type: 'multiple',
                    value: [30],
                    overwrite: false,
                },
                {
                    id: '31',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '4427',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
            ],
        },
        uk: {
            contactListId: ['16182394'],
            fields: [
                {
                    id: '9690',
                    type: 'multiple',
                    value: [12],
                    overwrite: false,
                },
                {
                    id: '7596',
                    type: 'multiple',
                    value: [30],
                    overwrite: false,
                },
                {
                    id: '31',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '4430',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
            ],
        },
        de: {
            contactListId: ['236549250'],
            fields: [
                {
                    id: '9690',
                    type: 'multiple',
                    value: [12],
                    overwrite: false,
                },
                {
                    id: '7596',
                    type: 'multiple',
                    value: [30],
                    overwrite: false,
                },
                {
                    id: '31',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '4425',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
            ],
        },
        fr: {
            contactListId: ['1053269597'],
            fields: [
                {
                    id: '9690',
                    type: 'multiple',
                    value: [12],
                    overwrite: false,
                },
                {
                    id: '7596',
                    type: 'multiple',
                    value: [30],
                    overwrite: false,
                },
                {
                    id: '31',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '4428',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
            ],
        },
        it: {
            contactListId: ['1998934371'],
            fields: [
                {
                    id: '9690',
                    type: 'multiple',
                    value: [12],
                    overwrite: false,
                },
                {
                    id: '7596',
                    type: 'multiple',
                    value: [30],
                    overwrite: false,
                },
                {
                    id: '31',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '4429',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
            ],
        },
        es: {
            contactListId: ['1772671024'],
            fields: [
                {
                    id: '9690',
                    type: 'multiple',
                    value: [12],
                    overwrite: false,
                },
                {
                    id: '7596',
                    type: 'multiple',
                    value: [30],
                    overwrite: false,
                },
                {
                    id: '31',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '4426',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
            ],
        },
        mx: {
            contactListId: ['1128345234'],
            isMulti: true,
            fields: [
                {
                    id: '11459',
                    type: 'single',
                    value: '1',
                    overwrite: true,
                },
                {
                    id: '12026',
                    type: 'multiple',
                    value: [1],
                    overwrite: false,
                },
            ],
        },
        ph: {
            contactListId: ['340522288'],
            fields: [
                {
                    id: '11457',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '31',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '9537',
                    type: 'multiple',
                    value: [15],
                    overwrite: false,
                },
            ],
        },
    };
    const emailConfig = emailConfigMap[locale] || emailConfigMap.us;
    const props = {
        needTerms: true,
        contactListId: emailConfig.contactListId,
        tipsObj: { btnText: t('btnText'), placeholder: t('placeholder') },
        fields: emailConfig.fields,
        isMulti: true,
        // isMulti: ['us', 'ca'].includes(locale)
    };

    const [active, setActive] = useState([0, 0]);
    const [hover, setHover] = useState([-1, -1]);

    const COLORS = ['kr', 'ph'].includes(locale)
        ? [{ color: '#dadada', text: t('color_item1') }]
        : [
              { color: '#dadada', text: t('color_item1') },
              { color: '#c0defe', text: t('color_item2') },
              { color: '#212121', text: t('color_item3') },
          ];

    const cards = [
        {
            subs: [
                'https://websiteoss.ecoflow.com/upload/image/1729671782323/a1.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1729671769338/a2.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1729671769212/a3.jpg',
            ],
            label: t('item_a1_label'),
            title: t('item_a1_title'),
            desc: t.rich('item_a1_subTitle', {
                sup: (text: string) => <sup className="sup">{text}</sup>,
            }),
            desc2: t('item_a1_desc'),
            free:
                IS_NA && pageStatus === 'statusA'
                    ? {
                          img: 'https://websiteoss.ecoflow.com/upload/image/1724914041291/20W.png',
                          label: t('item_a1_tip_t1'),
                          text: t('item_a1_tip_t2'),
                          off: locale === 'ca' ? 11 : 29,
                      }
                    : undefined,
            btn:
                pageStatus !== 'statusA'
                    ? {
                          type: 'buy',
                          link: `https://${locale}.ecoflow.com/products/rapid-magnetic-power-bank`,
                      }
                    : null,
        },
        {
            subs: [
                'https://websiteoss.ecoflow.com/upload/image/1729671769224/b1.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1729671769223/b2.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1729671769239/b3.jpg',
            ],
            label: t('item_b1_label'),
            title: t('item_b1_title'),
            desc: t.rich('item_b1_subTitle', {
                sup: (text: string) => <sup className="sup">{text}</sup>,
            }),
            desc2: t('item_b1_desc'),
            free:
                IS_NA && pageStatus === 'statusA'
                    ? {
                          img: 'https://websiteoss.ecoflow.com/upload/image/1724914041469/30W.png',
                          label: t('item_b1_tip_t1'),
                          text: t('item_b1_tip_t2'),
                          off: locale === 'us' ? 11 : undefined,
                      }
                    : undefined,
            btn:
                pageStatus !== 'statusA'
                    ? {
                          type: 'notify',
                      }
                    : null,
        },
    ];

    const [items, setItems] = useState([...cards]);

    const handleClick = (e: any, k: number, m: number) => {
        e.stopPropagation();
        const newActive = [...active];
        newActive[k] = m;
        setActive(newActive);
        if (window?.innerWidth <= 1024) {
            setHover([k, m]);
        }
    };

    const handleClickOut = (e) => {
        if (window?.innerWidth <= 1024 && !['outer', 'inner'].includes(e.target.className)) {
            setHover([-1, -1]);
        }
    };

    const handleOpenNotify = () => {
        setShowNotify(true);
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    useEffect(() => {
        if (pageStatus === 'statusB') {
            const newItems = [...items];
            if (active[0] === 0) {
                newItems[0].btn = {
                    type: 'buy',
                    link:
                        locale === 'ph'
                            ? 'https://ph.ecoflow.com/products/ecoflow-rapid-magnetic-power-bank-10000mah'
                            : `https://${locale}.ecoflow.com/products/rapid-magnetic-power-bank`,
                };
            } else {
                newItems[0].btn = {
                    type: 'notify',
                };
            }
            if (active[1] === 0 && IS_NA) {
                newItems[1].btn = {
                    type: 'buy',
                    link:
                        locale === 'mx'
                            ? 'https://mx.ecoflow.com/products/ecoflow-rapid-magnetic-power-bank?variant=42660683612239'
                            : `https://${locale}.ecoflow.com/products/ecoflow-rapid-magnetic-power-bank-10000mah`,
                };
            } else if (active[1] === 0 && IS_EU) {
                newItems[1].btn = {
                    type: 'buy',
                    link:
                        locale === 'kr'
                            ? 'https://kr.ecoflow.com/products/rapid-magnetic-power-bank?variant=45560945967273'
                            : `https://${locale}.ecoflow.com/products/rapid-magnetic-power-bank`,
                };
            } else if (locale === 'ph') {
                newItems[1].btn = {
                    type: 'buy',
                    disabled: true,
                };
            } else {
                newItems[1].btn = {
                    type: 'notify',
                };
            }
            setItems(newItems);
        }
    }, [pageStatus, active]);

    return (
        <div className={`${css.comp}`} onClick={handleClickOut}>
            <EfSpec className="spec-m" />
            {pageStatus === 'statusA' && (
                <>
                    <p className="title">
                        {t.rich('title', {
                            blue: (text: string) => <span className="blue">{text}</span>,
                        })}
                    </p>
                    <EfEmarsysEmail {...props} />
                </>
            )}
            <Swiper className="cards" slidesPerView={'auto'} initialSlide={0} spaceBetween={16}>
                {items.map((card: any, k: number) => (
                    <SwiperSlide className={`card ${card?.free ? 'has-free' : 'no-free'}`} key={k}>
                        <div className="card-img">
                            <EfImg pc={card.subs[active[k]]} />
                        </div>
                        {card?.free && (
                            <div className={`card-free ${card?.free?.off ? 'has-off' : 'no-off'}`}>
                                <div className="free-info">
                                    <div className="free-img">
                                        <EfImg pc={card?.free?.img} />
                                    </div>
                                    <div className="free-box">
                                        <span className="free-label">{card?.free?.label}</span>
                                        <p className="free-text">{card?.free?.text}</p>
                                    </div>
                                </div>
                                {card?.free?.off && (
                                    <>
                                        <div className="plus">
                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect width="18" height="18" rx="9" fill="black" />
                                                <path
                                                    fillRule="evenodd"
                                                    clipRule="evenodd"
                                                    d="M9.99999 4H7.99999V7.9998L4 7.9998V9.9998H7.99999V14H9.99999V9.9998H14V7.9998L9.99999 7.9998V4Z"
                                                    fill="white"
                                                />
                                            </svg>
                                        </div>
                                        <div className="free-off">
                                            <OFF className="pc" off={card?.free?.off} />
                                            <OFF_M className="h5" off={card?.free?.off} />
                                        </div>
                                    </>
                                )}
                            </div>
                        )}
                        <div className="card-info">
                            <div className="card-label" style={{ opacity: (card?.btn?.type !== 'buy' || (locale === 'ph' && k === 1)) && card?.label ? 1 : 0 }}>
                                {card.label}
                            </div>

                            {card?.title && <p className="card-title">{card.title}</p>}
                            <ul className="colors">
                                {COLORS?.map((color: any, m: number) => {
                                    if (k === 1 && m === 1 && IS_NA) return null;
                                    return (
                                        <li className={`color${active[k] === m ? ' active' : ''}`} key={k + '_' + m}>
                                            {hover[0] === k && hover[1] === m && <span className="color-text">{color.text}</span>}
                                            <span
                                                className="outer"
                                                style={{ borderColor: color.color }}
                                                onMouseEnter={() => setHover([k, m])}
                                                onMouseLeave={() => setHover([-1, -1])}
                                                onClick={(e) => handleClick(e, k, m)}
                                            >
                                                <span className="inner" style={{ backgroundColor: color.color }}></span>
                                            </span>
                                        </li>
                                    );
                                })}
                            </ul>
                            {card?.desc && <p className="card-desc">{card.desc}</p>}
                            {card?.desc2 && <p className="card-desc2">{card.desc2}</p>}
                            {card?.btn && (
                                <>
                                    {card?.btn?.type === 'buy' && (
                                        <EfLink
                                            className={`card-buy card-btn ${card?.btn?.disabled ? 'disabled' : ''}`}
                                            href={card?.btn?.disabled ? undefined : card?.btn?.link}
                                            target="_blank"
                                        >
                                            {t('buy')}
                                        </EfLink>
                                    )}
                                    {card?.btn?.type === 'notify' && (
                                        <button className="card-notify card-btn" onClick={handleOpenNotify}>
                                            {t('notify')}
                                        </button>
                                    )}
                                </>
                            )}
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            {showNotify && isClient && createPortal(<NotifyModal data={props} callback={() => setShowNotify(false)} />, document.body)}
            <EfSpec className="spec-m" />
        </div>
    );
}
